// extracted by mini-css-extract-plugin
export default {"title":"CutOffTime_title__Aw-Wp"};